import { useCallback } from 'react'
import { getAdminSummary } from '../../api/admin'
import { useAdminPoll, type AdminPoll } from './useAdminPoll'
import type { AdminSummary } from '../../adminApi'

/** How often the shell re-reads "is anything on fire". Our own tables; costs the provider nothing. */
export const SUMMARY_POLL_MS = 10_000

/**
 * The shell's own data source.
 *
 * One hook per data source, each independently testable, and **every panel fetches its own data**
 * — a failing health endpoint must not blank the live-matches panel next to it. This one is the
 * exception only in that the shell renders it before any panel mounts, and a panel whose own fetch
 * fails falls back to it.
 */
export function useAdminSummary(enabled: boolean): AdminPoll<AdminSummary> {
  const load = useCallback(() => getAdminSummary(), [])
  return useAdminPoll(load, { enabled, intervalMs: SUMMARY_POLL_MS })
}
